import { __decorate, __metadata } from "tslib";
import { SingletonService } from '@trp-dms-digital-shared/ds-ui-library-common';
import { gql } from '@apollo/client/core/index.js';
import { DadaApiService } from './dada-api.service.js';
let ProductListRequestApiService = class ProductListRequestApiService extends DadaApiService {
    request = {};
    constructor(endpoint, apikey) {
        super(endpoint, apikey);
    }
    getQuery() {
        return gql `query getProductList($productListRequest: DataListRequest){
      fetchDataList(req: $productListRequest) {
        type
        ${this.fragments}
      }
    }`;
    }
    updateRequest(newRequest, productListFragments) {
        this.request = {
            ...this.request,
            ...newRequest,
        };
        this.fragments = this.fragments.concat(productListFragments);
        if (!this.timeOutSet) {
            setTimeout(() => {
                let response = {};
                const apiQueryObservable = this.apolloClient.watchQuery({
                    query: gql `
            ${this.getQuery()}
          `,
                    variables: {
                        productListRequest: {
                            type: 'productListRequest',
                            context: {
                                audience: this.request.context?.audience,
                                country: this.request.context?.country,
                                language: this.request.context?.language,
                            },
                            productListRequest: {
                                productCodes: this.request.productCodes,
                                vehicle: this.request.vehicle,
                                vehicles: this.request.vehicles,
                            },
                        },
                    },
                });
                apiQueryObservable.subscribe((results) => {
                    response = results?.data?.fetchDataList;
                    this.apiSubject.next(response);
                    this.request = {};
                    this.timeOutSet = false;
                }, (error) => {
                    console.error('Product List Request api.service - updateRequest', error);
                    this.request = {};
                    this.timeOutSet = false;
                });
            }, this.timeOutSetting);
            this.timeOutSet = true;
        }
    }
};
ProductListRequestApiService = __decorate([
    SingletonService,
    __metadata("design:paramtypes", [String, String])
], ProductListRequestApiService);
export { ProductListRequestApiService };
//# sourceMappingURL=product-list-request-api.service.js.map